module.exports = __webpack_public_path__ + "img/acofi.85446c11.png";